import * as React from 'react';
import * as Modal from 'react-modal';
import { translate } from '@js/common/helpers';
var FEEDBACK_EMAIL = 'tech@tag-walk.com';
function buildFeedbackHref() {
    var subject = encodeURIComponent(translate('image_search.quota.feedback_subject'));
    var body = encodeURIComponent(translate('image_search.quota.feedback_body').replace(/\r?\n/g, '\r\n'));
    return "mailto:" + FEEDBACK_EMAIL + "?subject=" + subject + "&body=" + body;
}
var body = document.querySelector('body');
if (body) {
    Modal.setAppElement(body);
}
export function ImageSearchQuotaModal(props) {
    return (React.createElement(Modal, { isOpen: props.isOpen, onRequestClose: props.onClose, className: "image-search-modal tds", overlayClassName: "image-search-modal-overlay backdrop" },
        React.createElement("div", { className: "image-search-modal-header" },
            React.createElement("h2", { className: "image-search-modal-title" }, translate('image_search.modal_title')),
            React.createElement("button", { type: "button", className: "image-search-modal-close", onClick: props.onClose, "aria-label": translate('image_search.close') },
                React.createElement("i", { className: "iconoir-xmark" }))),
        React.createElement("div", { className: "image-search-modal-body image-search-quota" },
            React.createElement("span", { className: "image-search-quota-badge pill" }, translate('image_search.beta')),
            React.createElement("i", { className: "iconoir-hourglass image-search-quota-icon", "aria-hidden": "true" }),
            React.createElement("p", { className: "image-search-quota-eyebrow" }, translate('image_search.quota.eyebrow')),
            React.createElement("h3", { className: "image-search-quota-title" }, translate('image_search.quota.title')),
            React.createElement("p", { className: "image-search-quota-text" }, translate('image_search.quota.text')),
            React.createElement("a", { className: "image-search-quota-feedback", href: buildFeedbackHref(), target: "_blank", rel: "noopener noreferrer" }, translate('image_search.quota.feedback')))));
}
